export const BUSINESS_DOCUMENT_TYPE = {
  CPF: 'cpf',
  CNPJ: 'cnpj',
};

// kind responde se este e o negocio raiz da pessoa, nao se e PF ou PJ. Quem
// responde PF ou PJ e o document_type.
export const BUSINESS_KIND = {
  PERSONAL: 'personal',
  ADDITIONAL: 'additional',
};

// Valor de data-tour do seletor: o destaque de migracao (CBK-528) se ancora nele.
export const BUSINESS_SWITCHER_ANCHOR = 'business-switcher';

export const BUSINESS_UI_STATUS = {
  APPROVED: 'approved',
  IN_REVIEW: 'in_review',
  REJECTED: 'rejected',
};

export const BUSINESS_UI_STATUS_LABEL = {
  [BUSINESS_UI_STATUS.APPROVED]: 'Aprovado',
  [BUSINESS_UI_STATUS.IN_REVIEW]: 'Em análise',
  [BUSINESS_UI_STATUS.REJECTED]: 'Reprovado',
};

// O protótipo usa azul em Em análise. O info do tema é ciano e destoava do
// restante da tela; o secondary é o azul da paleta.
export const BUSINESS_UI_STATUS_COLOR = {
  [BUSINESS_UI_STATUS.APPROVED]: 'success',
  [BUSINESS_UI_STATUS.IN_REVIEW]: 'secondary',
  [BUSINESS_UI_STATUS.REJECTED]: 'warning',
};

export const REJECTION_COLOR = {
  FIXABLE: 'warning',
  DEFINITIVE: 'error',
};

export const rejectionColor = (rejection) =>
  rejection?.canFix === false ? REJECTION_COLOR.DEFINITIVE : REJECTION_COLOR.FIXABLE;

export const businessUiStatusColor = (business) =>
  business?.uiStatus === BUSINESS_UI_STATUS.REJECTED
    ? rejectionColor(business?.rejection)
    : BUSINESS_UI_STATUS_COLOR[business?.uiStatus];

const normalizeStatusValue = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase();

const UI_STATUS_VALUES = Object.values(BUSINESS_UI_STATUS);

// O backend ja manda ui_status e e a mesma regra que bloqueia no servidor.
// Recalcular aqui so serve de queda quando o campo nao vier.
export const parseBusinessUiStatus = (value) => {
  const uiStatus = normalizeStatusValue(value);

  return UI_STATUS_VALUES.includes(uiStatus) ? uiStatus : null;
};

// A API ja devolve na ordem pedida pelo RF-08 (default, Aprovados, Em analise,
// Reprovados). Aqui so sobe o negocio ativo, que e informacao do front.
export const sortBusinessesForSwitcher = (businesses = [], activeBusinessId = null) => {
  if (activeBusinessId === null || activeBusinessId === undefined) {
    return [...businesses];
  }

  const activeId = String(activeBusinessId);
  const active = businesses.filter((business) => String(business.id) === activeId);
  const others = businesses.filter((business) => String(business.id) !== activeId);

  return [...active, ...others];
};
